import format from './lib/format'
import {format as dateFormat} from 'date-fns'


export default function install(Vue) {
  if (install.installed) return
  install.installed = true

  Vue.filter('number', function(value){
    return value.toString().replace(',', '.')
  })

  Vue.filter('date', function(value, format = 'DD.MM.YYYY'){
    return dateFormat(value, format)
  })

  Vue.filter('pluralize', function(value, amount){
    return format.pluralize(value, amount)
  })

  Vue.filter('translation', function(value){
    return format.translation(value)
  })

  Vue.filter('languages', function(value){
    return value.map(l => process.env.LANGUAGES_SHORT[l]).join(', ')
  })


  Object.defineProperty(Vue.prototype, '$translationMissing', {
    get(){
      return function(value){
        if(value && typeof value === 'string' && value.match(/^<.+?>\s/)) return 'translation-missing'
      }
    }
  })



  Vue.prototype.$attrFilter = function(obj, attrs){
    const tmp = {}

    attrs.forEach(attr => {
      tmp[attr] = obj[attr] || null
    })

    return tmp
  }


  Vue.prototype.$attrClone = function(obj, attrs, overrides){
    const tmp = Object.assign({}, obj, overrides)

    attrs.forEach(attr => {
      tmp[attr] = overrides[attr] || obj[attr] || null
    })

    return tmp
  }


  Vue.prototype.$successNotification = function(message){
    this.$toast.open({
      message,
      type: 'is-success'
    })
  }

  Vue.prototype.$errorNotification = function(error, message){
    console.log('ERROR:', error)
    this.$toast.open({
      message,
      type: 'is-danger'
    })
  }
}



// WEBPACK FOOTER //
// ./shared/filters.js